import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

import List from './input-list/list'
import Table from './input-table/table'

class Input extends Component {
  constructor(props) {
    super(props)

    this.state = {
      listView: false,
      fullView: false
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { rider } = nextProps

    if (rider !== this.props.rider) return true
    if (nextState !== this.state) return true
    return false
  }

  render() {
    const { view, rider, stageElements } = this.props
    const { listView, fullView } = this.state

    const className = classnames({
      'input': true,
      'input-list': listView === true,
      'input-table': listView === false,
      'section--full': fullView
    })

    const enlargeButtonClassName = classnames({
      'button--success': true,
      'enlarge-button': true,
      'enlarge-button--active': fullView === true
    })

    return (
      <section className={className}>
        <div className="section-head">
          <h2>Input {listView ? 'List' : 'Table'}</h2>

          <button className="view-button button--success" onClick={() => this.setState({listView: !listView, fullView: false})}>
            {
              listView
              ? 'Switch to Table view'
              : 'Switch to List view'
            }
          </button>

          {
            !listView
            ? <button className={enlargeButtonClassName} onClick={() => this.setState({fullView: !fullView})} />
            : null
          }
        </div>

        {
          listView
          ? <List
              view={view}
              group={this.props.group}
              columns={rider.columns}
              items={rider.items}
              itemGroups={rider.itemGroups}
              createRiderColumn={this.props.createRiderColumn}
              addRiderItem={this.props.addRiderItem}
              removeRiderItem={this.props.removeRiderItem}
              createRiderItem={this.props.createRiderItem}
              createRiderItems={this.props.createRiderItems}
              editRiderItem={this.props.editRiderItem}
              moveRiderItem={this.props.moveRiderItem}
              deleteRiderItem={this.props.deleteRiderItem}
              stageElements={stageElements}
              createStageElement={this.props.createStageElement}
              getSearchResults={this.props.getSearchResults} />
          : <Table
              view={view}
              fullView={fullView}
              group={this.props.group}
              columns={rider.columns}
              addRiderColumn={this.props.addRiderColumn}
              removeRiderColumn={this.props.removeRiderColumn}
              createRiderColumn={this.props.createRiderColumn}
              moveRiderColumn={this.props.moveRiderColumn}
              deleteRiderColumn={this.props.deleteRiderColumn}
              items={rider.items}
              itemGroups={rider.itemGroups}
              addRiderItem={this.props.addRiderItem}
              removeRiderItem={this.props.removeRiderItem}
              createRiderItem={this.props.createRiderItem}
              createRiderItems={this.props.createRiderItems}
              editRiderItem={this.props.editRiderItem}
              moveRiderItem={this.props.moveRiderItem}
              deleteRiderItem={this.props.deleteRiderItem}
              stageElements={stageElements}
              createStageElement={this.props.createStageElement}
              getSearchResults={this.props.getSearchResults} />
        }
      </section>
    )
  }
}

Input.propTypes = {
  view: PropTypes.object,
  group: PropTypes.string,
  rider: PropTypes.object,
  addRiderColumn: PropTypes.func,
  removeRiderColumn: PropTypes.func,
  createRiderColumn: PropTypes.func,
  moveRiderColumn: PropTypes.func,
  deleteRiderColumn: PropTypes.func,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  createRiderItems: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  stageElements: PropTypes.object,
  createStageElement: PropTypes.func,
  getSearchResults: PropTypes.func,
  setModal: PropTypes.func
}

Input.defaultProps = {
  view: {},
  group: '',
  rider: { isFetching: true },
  addRiderColumn: function() {},
  removeRiderColumn: function() {},
  createRiderColumn: function() {},
  moveRiderColumn: function() {},
  deleteRiderColumn: function() {},
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  createRiderItems: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {},
  stageElements: {},
  createStageElement: function() {},
  getSearchResults: function() {},
  setModal: function() {}
}

export default Input



// WEBPACK FOOTER //
// ./src/components/rider/rider-input/input.js